/** The six default status colours. A status that plainly matches one names it instead of carrying its own colour. */
export enum StatusToneEnum {
  Draft = 'Draft',
  Active = 'Active',
  InProgress = 'InProgress',
  Inactive = 'Inactive',
  Cancelled = 'Cancelled',
  Failure = 'Failure',
}

/** A status map entry's colour: one default tone, or a colour of its own when no tone plainly matches. */
export type StatusColor = { tone: StatusToneEnum } | { color: string }
